import clsx from 'clsx';

interface Props {
  name: string;
  color: 'violet' | 'teal' | 'amber';
  size?: StandardSizes;
  width?: string | number;
}

export const SettingTag = ({ color, name, size = 'md', width }: Props) => {
  const classes = useStyles();

  return (
    <p
      style={{ width: width }}
      className={clsx(classes.tag, classes.color[color], classes.size[size])}
    >
      {name}
    </p>
  );
};

const useStyles = () => ({
  tag: 'flex justify-center min-w-fit h-fit whitespace-nowrap rounded my-auto text-xs',
  color: {
    amber: 'bg-amber-200 text-amber-900',
    teal: 'bg-teal-200 text-teal-900',
    violet: 'bg-violet-200 text-violet-900',
  },
  size: {
    sm: 'p-1 w-[80px]',
    md: 'px-2 py-2 w-[120px]',
    lg: 'px-3 py-2 w-[150px]',
  },
});
